// write a function to return true if the RAN option is disabled
// it takes ranOverride as a string or array of strings and targetRan as a string
// if no ranOverride is provided, return false
// if ranOverride is a string, check if it is equal to the targetRan, if so return false
// if ranOverride is an array, check if targetRan is included in the array, if so return false
// otherwise return true

export const isRANOptionDisabled = (ranOverride, targetRan) => {

  if (!ranOverride) return false;

  if (typeof ranOverride === 'string') {
    return ranOverride !== targetRan;
  }

  if (Array.isArray(ranOverride)) {
    return !ranOverride.includes(targetRan);
  }

  return true;
}